export default __webpack_public_path__ + "static/triangle2-a5da0b3731656d251241a66607f4ce3c.svg";